import { render, staticRenderFns } from "./SmsMessage.vue?vue&type=template&id=93cf42c8&"
import script from "./SmsMessage.vue?vue&type=script&lang=js&"
export * from "./SmsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports